<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap>
      <table cellpadding="0" cellspacing="0" id="associated">
        <tr>
          <th>
            Created
          </th>
          <th>
            Amount
          </th>
          <th>
            Fee
          </th>
          <th>
            Type
          </th>
          <th>
            Start Date
          </th>
          <th>
            End Date
          </th>
          <th>
            Notify
          </th>
          <th>
            # Payments
          </th>
        </tr>
        <tr v-if="transaction.parent_tracking_id">
          <td>
            {{ datetime(transaction.parent_created) }}
          </td>
          <td>
            {{ money((transaction.parent_total_amount - transaction.parent_fee_amount) / 100) }}
          </td>
          <td>
            {{ money(transaction.parent_fee_amount / 100) }}
          </td>
          <td>
            {{ transaction.parent_recurring_type }}
          </td>
          <td>
            {{ dateUtc(transaction.parent_recurring_start) }}
          </td>
          <td>
            {{ formatEndDate(transaction.parent_recurring_end) }}
          </td>
          <td>
            {{ transaction.parent_notify ? 'Yes' : 'No' }}
          </td>
          <td>
            {{ calculatePaymentCount({ recurring_type: transaction.parent_recurring_type, start: transaction.parent_recurring_start, end: transaction.parent_recurring_end }) }}
          </td>
        </tr>
        <tr v-else>
          <td>
            {{ datetime(transaction.created) }}
          </td>
          <td>
            {{ money((transaction.total_amount - transaction.fee_amount) / 100) }}
          </td>
          <td>
            {{ money(transaction.fee_amount / 100) }}
          </td>
          <td>
            {{ transaction.recurring_type }}
          </td>
          <td>
            {{ dateUtc(transaction.start) }}
          </td>
          <td>
            {{ formatEndDate(transaction.end) }}
          </td>
          <td>
            {{ transaction.notify ? 'Yes' : 'No' }}
          </td>
          <td>
            {{ calculatePaymentCount({ recurring_type: transaction.recurring_type, start: transaction.start, end: transaction.end }) }}
          </td>
        </tr>
        <tr
          v-for="(row) in associatedSorted"
          v-if="row.request_type === 'modify' && row.response_code === '000'"
          :key="row.id"
        >
          <td>
            {{ datetime(row.created) }}
          </td>
          <td>
            {{ money((row.total_amount - row.fee_amount) / 100) }}
          </td>
          <td>
            {{ money(row.fee_amount / 100) }}
          </td>
          <td>
            {{ row.recurring_type }}
          </td>
          <td>
            {{ row.recurring_start || row.start ? dateUtc(row.recurring_start || row.start) : '-' }}
          </td>
          <td>
            {{ row.recurring_end || row.end ? formatEndDate(row.recurring_end || row.end) : '-' }}
          </td>
          <td>
            {{ row.recurring_notify ? 'Yes' : 'No' }}
          </td>
          <td>
            {{ calculatePaymentCount(row) }}
          </td>
        </tr>
      </table>
    </v-layout>
  </v-container>
</template>

<script>
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, RecurringMixin, StoreMixin],

  data: function () {
    return {
      enabled: false
    }
  },

  props: {
    transaction: Object
  },

  computed: {
    associatedSorted: function () {
      // @TODO are we killing reactivity... do we care?
      return [...(this.transaction.associatedTransactions || [])].reverse()
    }
  },

  methods: {
    isOngoingDate (dateStr) {
      if (!dateStr) return false
      return dateStr.includes('2099-12-31')
    },

    formatEndDate (dateStr) {
      if (!dateStr) return '-'
      if (this.isOngoingDate(dateStr)) return 'Ongoing'
      return this.dateUtc(dateStr)
    },

    calculatePaymentCount (row) {
      let start = row.start || row.recurring_start
      let end = row.end || row.recurring_end
      let type = row.recurring_type

      if (!start || !end) return '-'
      if (this.isOngoingDate(end)) return 'Ongoing'
      return this.calculatePaymentCountWithEndDate(type, start, end)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/recurring/Modifications.vue